<template>
  <div class="container">
    <transition name="fade">
      <Loading @loadSuccess="loadSuccess" v-show="isShowLoading" />
    </transition>
    <div>
      <div class="menu-container" v-if="this.homeSwiper && this.homeSwiper.activeIndex >= 1">
        <div class="menu-fab spread" :class="{ 'spread-hide': openMenu }">
          <div class="menu-text" @click="changeOpenMenu">
            目录
            <div class="arrow-right-icon" />
          </div>
        </div>
        <div class="menu-fab function" :class="{ 'function-show': openMenu }" @mouseleave="menuLeave" @mouseenter="menuEnter">
          <div class="menu-text" @click="changeOpenMenu">
            <div class="arrow-left-icon" />
            收起
          </div>
          <div class="menu-items">
            <div class="menu-item" :class="{ 'menu-item-active': homeSwiper && homeSwiper.activeIndex === 0 }" @click="changeSwiper(0)">
              <div>前述</div>
            </div>
            <div class="arrow-right-double" />
            <div class="menu-item" :class="{ 'menu-item-active': homeSwiper && homeSwiper.activeIndex === 1 }" @click="changeSwiper(1)">
              <div>田野发布会</div>
            </div>
            <div class="arrow-right-double" />
            <div class="menu-item" :class="{ 'menu-item-active': homeSwiper && homeSwiper.activeIndex === 2 }" @click="changeSwiper(2)">
              <div>社区工作者</div>
            </div>
            <div class="arrow-right-double" />
            <div class="menu-item" :class="{ 'menu-item-active': homeSwiper && homeSwiper.activeIndex === 3 }" @click="changeSwiper(3)">
              <div>摄影师</div>
            </div>
            <div class="arrow-right-double" />
            <div class="menu-item" :class="{ 'menu-item-active': homeSwiper && homeSwiper.activeIndex === 4 }" @click="changeSwiper(4)">
              <div>见义勇为</div>
            </div>
            <div class="arrow-right-double" />
            <div class="menu-item" :class="{ 'menu-item-active': homeSwiper && homeSwiper.activeIndex === 5 }" @click="changeSwiper(5)">
              <div>甬凉山海情</div>
            </div>
            <div class="arrow-right-double" />
            <div class="menu-item" :class="{ 'menu-item-active': homeSwiper && homeSwiper.activeIndex === 6 }" @click="changeSwiper(6)">
              <div>技能人才</div>
            </div>
            <div class="arrow-right-double" />
            <div class="menu-item" :class="{ 'menu-item-active': homeSwiper && homeSwiper.activeIndex === 7 }" @click="changeSwiper(7)">
              <div>时间轴</div>
            </div>
            <div class="arrow-right-double" />
            <div class="menu-item" :class="{ 'menu-item-active': homeSwiper && homeSwiper.activeIndex === 8 }" @click="changeSwiper(8)">
              <div>结束语</div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-btn-left" v-show="homeSwiper && homeSwiper.activeIndex > 0" @click="swiperLeft"></div>
      <div class="swiper-btn-right ani-btnRight" @click="swiperRight" id="swiper-btn-right" v-show="swiperRightBtn && homeSwiper && homeSwiper.activeIndex < 8"></div>
      <div class="swiper-container" id="home-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide swiper-no-swiping swiper-slide1">
            <Introduction ref="introduction" @startBgm="startBgm" @showSwiperRight="openRightBtn" />
          </div>
          <div class="swiper-slide swiper-no-swiping swiper-slide4">
            <Field ref="field" @openModal="openModal" @openMp3Modal="openMp3Modal" @playAudio="playAudio" @end="scrollEnd" />
          </div>
          <div class="swiper-slide swiper-no-swiping swiper-slide3">
            <ShuJi ref="shuji" @openModal="openModal" @openMp3Modal="openMp3Modal" @playAudio="playAudio" @end="scrollEnd" @showNvModal="openNvModal" />
          </div>
          <div class="swiper-slide swiper-no-swiping swiper-slide5">
            <Camera ref="camera" @openModal="openModal" @openMp3Modal="openMp3Modal" @playAudio="playAudio" @end="scrollEnd" />
          </div>

          <div class="swiper-slide swiper-no-swiping swiper-slide6">
            <Brave ref="brave" @openModal="openModal" @openMp3Modal="openMp3Modal" @playAudio="playAudio" @end="scrollEnd" />
          </div>

          <div class="swiper-slide swiper-no-swiping swiper-slide10">
            <LiangShan ref="liangshan" @openModal="openModal" @openMp3Modal="openMp3Modal" @playAudio="playAudio" @end="scrollEnd" />
          </div>
          <div class="swiper-slide swiper-no-swiping swiper-slide7">
            <Skill ref="skill" @openModal="openModal" @openMp3Modal="openMp3Modal" @playAudio="playAudio" @end="scrollEnd" />
          </div>

          <div class="swiper-slide swiper-no-swiping swiper-slide8">
            <TimeLine ref="timeLine" @openModal="openModal" />
          </div>
          <div class="swiper-slide swiper-no-swiping swiper-slide9">
            <Comment ref="comment" @toast="toast" @loading="handleLoading" />
          </div>
        </div>
      </div>

      <div v-show="showBgmIcon" class="music" :class="{ 'music-on': bgmMusicSwitch, 'music-off': !bgmMusicSwitch }" @click="switchBgm"></div>
    </div>
    <audio id="music-bgm" preload loop ref="musicBgm">
      <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/music/bgm.mp3" />
    </audio>
    <audio id="field-ganyan" preload>
      <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/field/fpjcf.mp3" />
    </audio>
    <audio id="skill-ganyan" preload>
      <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/skill/zjs.mp3" />
    </audio>
    <div id="field-music-contianer">
      <audio id="music-field-wang" data-img="wang-talk1" data-end-left="14078" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/field/wang.mp3" />
      </audio>
      <audio id="music-field-msg-1" data-img="field-msg-1" data-end-left="14078" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/msg.mp3" />
      </audio>
      <audio id="music-field-msg-2" data-img="field-msg-2" data-end-left="14078" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/msg.mp3" />
      </audio>
      <audio id="music-field-msg-3" data-img="field-msg-3" data-end-left="14078" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/msg.mp3" />
      </audio>
      <audio id="music-field-air" data-img="field-air" data-end-left="14078" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/field/air.mp3" />
      </audio>
      <audio id="music-field-cai" data-img="field-cai" data-end-left="14078" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/field/cai.mp3" />
      </audio>
      <audio id="music-chen-talk1" data-img="chen-talk1" data-end-left="14078" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/field/chen.mp3" />
      </audio>
    </div>
    <div id="shuji-music-contianer">
      <audio id="music-shuji-talk1" data-img="shuji-talk1" data-end-left="18692" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/shuji/shuji.mp3" />
      </audio>
      <audio id="music-shuji-gongdi" data-img="shuji-gongdi" data-end-left="18692" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/shuji/gongdi.mp3" />
      </audio>
      <audio id="music-shuji-msg-1" data-img="shuji-msg-1" data-end-left="18692" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/msg.mp3" />
      </audio>
      <audio id="music-shuji-msg-2" data-img="shuji-msg-2" data-end-left="18692" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/msg.mp3" />
      </audio>
    </div>
    <div id="camera-music-contianer">
      <audio id="music-camera-talk1" data-img="camera-talk1" data-end-left="14227" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/camera/xjf.mp3" />
      </audio>
      <audio id="music-camera-kuaimen" data-img="flip-card1" data-end-left="14227" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/camera/kuaimen.mp3" />
      </audio>
      <audio id="music-camera-kuaimen2" data-img="flip-card2" data-end-left="14227" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/camera/kuaimen.mp3" />
      </audio>
    </div>

    <div id="brave-music-contianer">
      <audio id="music-brave-talk1" data-img="brave-talk1" data-end-left="18164" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/brave/cms.mp3" />
      </audio>
      <audio id="music-brave-talk2" data-img="brave-talk2" data-end-left="18164" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/brave/xrba3.mp3" />
      </audio>
      <audio id="music-brave-talk3" data-img="brave-talk3" data-end-left="18164" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/brave/woyaojiuta2.mp3" />
      </audio>
    </div>
    <div id="skill-music-contianer">
      <audio id="music-skill-talk1" data-img="skill-talk1" data-end-left="9343" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/skill/xj.mp3" />
      </audio>
    </div>
    <div id="liangshan-music-contianer">
      <audio id="music-liangshan-talk1" data-img="liangshan-talk1" data-end-left="19526" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/liangshan/xin2.mp3" />
      </audio>
      <audio id="music-liangshan-talk2" data-img="liangshan-talk2" data-end-left="19526" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/liangshan/teng.mp3" />
      </audio>
      <audio id="music-liangshan-talk3" data-img="liangshan-talk3" data-end-left="19526" preload>
        <source src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/liangshan/jiewei.mp3" />
      </audio>
    </div>

    <transition name="pop" appear>
      <div class="modal" v-if="mp3ModalVisible">
        <div class="ganyan-container" v-if="mp3ModalParams" :style="{ border: '4px solid ' + mp3ModalParams.color }">
          <div class="main" style="{ color: mp3ModalParams.color }">
            <div class="head">
              <div class="line" :style="{ 'background-color': mp3ModalParams.color }" />
              <div class="img-wrap"><img :src="mp3ModalParams.mp3Gif" /></div>
            </div>
            <div class="content">
              <div class="content-item" v-for="(item, index) in mp3ModalParams.items" :key="index">{{ item }}</div>
            </div>
            <div class="dang">——{{ mp3ModalParams.dang }}</div>
            <div class="name">
              <img :src="mp3ModalParams.name" />
            </div>
          </div>
          <img class="avatar" :src="mp3ModalParams.avatar" />
          <div class="close-wrap" @click="closeMp3Modal" :style="{ 'background-color': mp3ModalParams.color }">
            <div class="close-icon" />
          </div>
        </div>
      </div>
    </transition>
    <transition name="pop" appear>
      <div class="modal" v-if="modalVisible">
        <div class="modal-wrap">
          <div class="modal-header" :style="{ 'background-color': modalParams.backgroundColor }">
            <div class="modal-header-wrap" :style="{ background: 'url(' + modalParams.titleImg + ') no-repeat', 'background-size': '100% 100%' }" />
          </div>
          <div class="modal-content" :style="{ border: '8px solid ' + modalParams.backgroundColor }">
            <video :src="modalParams.videoUrl" controls autoplay controlslist="nodownload noremoteplayback noplaybackrate" disablePictureInPicture />
          </div>
          <div class="modal-close" :style="{ 'background-color': modalParams.backgroundColor }" @click="closeModal">
            <div>关</div>
            <div>闭</div>
            <div class="close-icon" />
          </div>
        </div>
      </div>
    </transition>
    <transition name="pop" appear>
      <div class="modal" v-if="showNvModal" style="background-color: #00000090;">
        <div class="modal-nver">
          <video src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/shuji/nver2.mp4" controls autoplay controlslist="nodownload noremoteplayback noplaybackrate" disablePictureInPicture />
          <div class="nv-content">
            妈妈，在我心里，你一直是我的榜样。你的工作忙碌而琐碎，但我和爸爸会永远理解你、支持你，希望你不要被“母亲”这个标签所累，能够永远开心地做你自己。
          </div>
          <div class="modal-close" @click="closeNvModal">
            <div class="close-icon" />
          </div>
        </div>
      </div>
    </transition>

    <div class="modal modal-mask " v-if="toastVisible">
      <div class="modal-wrap">
        <div class="toast-content">
          {{ toastContent }}
        </div>
      </div>
    </div>

    <div class="modal modal-mask " v-if="loadingVisible">
      <div class="modal-wrap">
        <div class="loading-content">
          <div class="loading-icon" />
          <div class="loading-text">加载中...</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Loading from '@/components/Loading/index.vue'
import Field from '@/components/Field/index.vue'
import ShuJi from '@/components/ShuJi/index.vue'
import Camera from '@/components/Camera/index.vue'
import TimeLine from '@/components/TimeLine/index.vue'
import Comment from '@/components/Comment/index.vue'
import Brave from '@/components/Brave/index.vue'
import Skill from '@/components/Skill/index.vue'
import LiangShan from '@/components/LiangShan/index.vue'
import Introduction from '@/components/Introduction/index.vue'
import Swiper from 'swiper' // 注意引入的是Swiper
import 'swiper/css/swiper.min.css' // 注意这里的引入
export default {
  name: 'Home',
  //import引入的组件需要注入到对象中才能使用
  components: {
    Loading,
    Field,
    ShuJi,
    Camera,
    TimeLine,
    Comment,
    Brave,
    Skill,
    LiangShan,
    Introduction
  },
  data() {
    //这里存放数据
    return {
      isShowLoading: true,
      isShowHome: false,
      homeSwiper: null,
      btnSwiperFlag: false,
      homeSwiperIndex: 0,
      swiperChanging: false,
      showBgmIcon: false,
      bgmMusicSwitch: false,
      beforeBgmSwitch: false,
      modalVisible: false,
      modalParams: {},
      mp3ModalVisible: false,
      mp3ModalParams: null,
      // 当前正在播放的音乐
      currentAudio: null,
      // 弹窗内容
      toastContent: '',
      toastVisible: false,
      toastTimer: null,
      // loading弹窗
      loadingVisible: false,
      // 目录
      openMenu: false,
      swiperRightBtn: false,
      // 女儿
      showNvModal: false
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    closeNvModal() {
      this.restoreBgm()
      this.showNvModal = false
    },
    openNvModal() {
      this.beforeBgmSwitch = this.bgmMusicSwitch
      this.pauseBgm()
      this.closeAudio()
      this.showNvModal = true
    },
    menuEnter() {
      if (this.menuTime) {
        clearTimeout(this.menuTime)
      }
    },
    menuLeave() {
      this.menuTime = setTimeout(() => {
        this.openMenu = false
      }, 3000)
    },
    openRightBtn() {
      this.swiperRightBtn = true
    },
    startBgm() {
      this.showBgmIcon = true
      this.initBgm()
    },
    changeOpenMenu() {
      this.openMenu = !this.openMenu
    },

    handleLoading(event) {
      this.loadingVisible = event
    },
    toast(msg) {
      if (this.toastVisible) return
      this.toastContent = msg
      console.log(msg)
      this.toastVisible = true
      setTimeout(() => {
        this.toastVisible = false
      }, 2000)
    },
    scrollEnd() {
      const swiperBtnRight = document.getElementById('swiper-btn-right')
      swiperBtnRight.classList.remove('ani-btnRight')
      setTimeout(() => {
        swiperBtnRight.classList.add('ani-btnRight')
      }, 300)
    },
    closeMp3Modal() {
      this.restoreBgm()
      this.mp3ModalVisible = false
      this.mp3ModalParams.audioDom.pause()
      this.mp3ModalParams.audioDom.currentTime = 0
    },
    openMp3Modal(event) {
      this.beforeBgmSwitch = this.bgmMusicSwitch
      this.pauseBgm()
      this.closeAudio()
      const audioDom = document.getElementById(event.mode)
      if (audioDom) {
        this.mp3ModalParams = Object.assign(event, { audioDom })
        this.mp3ModalVisible = true
        audioDom.play()
      }
    },
    closeModal() {
      this.restoreBgm()
      this.modalVisible = false
    },
    openModal(event) {
      this.beforeBgmSwitch = this.bgmMusicSwitch
      this.pauseBgm()
      this.closeAudio()
      this.modalParams = Object.assign(
        {
          backgroundColor: '#f4bc45',
          titleImg: 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/wang/modal-title.png',
          videoUrl: 'https://res.cqnews.net/ires/2023/6/16/dSvys0Kwb7yDihF0xkX3DCXc6q8sCXWpD9i.mp4'
        },
        event
      )
      this.modalVisible = true
      // console.log(this.modalParams)
    },
    closeAudio() {
      if (!this.currentAudio) return
      this.currentAudio.pause()
      this.currentAudio.currentTime = 0
      this.currentAudio = null
    },
    playAudio(audio) {
      // 暂停当前正在播放的音频
      if (this.currentAudio && this.currentAudio !== audio) {
        this.currentAudio.pause()
        this.currentAudio.currentTime = 0
      }
      // 切换播放状态
      if (audio.paused) {
        audio.play()
        this.currentAudio = audio
      } else {
        audio.pause()
        audio.currentTime = 0
        this.currentAudio = null
      }
    },
    initBgm() {
      const musicBgm = this.$refs.musicBgm
      musicBgm.volume = 0.4
      musicBgm.play()
      this.bgmMusicSwitch = true
    },
    switchBgm() {
      if (this.bgmMusicSwitch) {
        this.bgmMusicSwitch = false
        this.$refs.musicBgm.pause()
      } else {
        this.bgmMusicSwitch = true
        this.$refs.musicBgm.play()
      }
    },
    pauseBgm() {
      this.bgmMusicSwitch = false
      this.$refs.musicBgm.pause()
    },
    restoreBgm() {
      this.bgmMusicSwitch = this.beforeBgmSwitch
      if (this.bgmMusicSwitch) {
        this.$refs.musicBgm.play()
      } else {
        this.$refs.musicBgm.pause()
      }
    },
    changeSwiper(index) {
      if (index === this.homeSwiper.activeIndex) return
      if (this.swiperChanging) return
      this.swiperChanging = true
      this.homeSwiper.slideTo(index)
    },
    swiperLeft() {
      if (this.swiperChanging) return
      if (this.homeSwiper.activeIndex <= 0) return
      this.homeSwiper.slidePrev()
    },
    swiperRight() {
      if (this.swiperChanging) return
      if (this.homeSwiper.isEnd) return
      this.homeSwiper.slideNext()
    },
    initSwiper() {
      this.homeSwiper = new Swiper('#home-swiper', {
        on: {
          transitionEnd: () => {
            this.swiperChanging = false
          },
          slideChange: () => {
            this.closeAudio()
            this.longImgInit()
          }
        }
      })
    },
    longImgInit() {
      if (this.homeSwiper.activeIndex === 1) {
        this.$refs.field.reset()
      }
      if (this.homeSwiper.activeIndex === 2) {
        this.$refs.shuji.reset()
      }
      if (this.homeSwiper.activeIndex === 3) {
        this.$refs.camera.reset()
      }
      if (this.homeSwiper.activeIndex === 4) {
        this.$refs.brave.reset()
      }
      if (this.homeSwiper.activeIndex === 5) {
        this.$refs.liangshan.reset()
      }
      if (this.homeSwiper.activeIndex === 6) {
        this.$refs.skill.reset()
      }
      if (this.homeSwiper.activeIndex === 7) {
        this.$refs.timeLine.init()
      }
      if (this.homeSwiper.activeIndex === 8) {
        this.$refs.comment.init()
      }
    },
    loadSuccess() {
      this.isShowLoading = false
      this.$refs.introduction.init()
      // this.isShowHome = true
      this.$nextTick(() => {
        this.initSwiper()
        this.$refs.field.init()
        this.$refs.shuji.init()
        this.$refs.camera.init()
        this.$refs.brave.init()
        this.$refs.skill.init()
        this.$refs.liangshan.init()
      })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.container {
  overflow: hidden;
  width: 100%;
  height: 100%;
  // position: relative;
}
.ganyan-container {
  width: 400px;
  background-color: #fff;
  // border: 4px solid #2754bf;
  border-radius: 20px;
  position: relative;
  padding-top: 80px;
  padding-bottom: 20px;
  .main {
    padding: 0 24px;
    font-size: 20px;
    // color: #2754bf;
    line-height: 32px;

    .head {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      position: relative;
      .img-wrap {
        background-color: #fff;
        z-index: 2;
        img {
          width: 130px;
          z-index: 2;
        }
      }

      .line {
        height: 1px;
        // background-color: #2754bf;
        width: 100%;
        position: absolute;
        bottom: 3px;
      }
    }
    .content {
      font-size: 24px;
      margin: 32px 0;
      font-family: '楷体', '楷体_GB2312';
      .content-item {
        text-indent: 2em;
      }
    }
    .dang {
      text-align: right;
    }
    .name {
      margin-top: 12px;
      text-align: right;
      img {
        width: 80px;
      }
    }
  }
  .avatar {
    position: absolute;
    width: 190px;
    left: 50%;
    transform: translateX(-50%);
    top: -127px;
  }
  .close-wrap {
    position: absolute;
    top: -20px;
    right: 24px;
    // background-color: #2754bf;
    border-radius: 50%;
    padding: 8px;
    cursor: pointer;
    .close-icon {
      width: 20px;
      height: 20px;
      background: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/close.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}
.menu-container {
  font-family: '楷体', '楷体_GB2312';
}
.menu-items {
  display: flex;
  align-items: center;
}
.menu-item {
  display: flex;
  align-items: center;
  font-size: 25px;
  background-color: #00000070;
  color: #fff;
  padding: 12px 18px 12px 18px;
  border-radius: 30px;
  cursor: pointer;
  // margin-left: 24px;
}
.menu-item-active {
  color: #ffed53;
}
.arrow-right-double {
  margin: 0 8px;
  width: 40px;
  height: 40px;
  background: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/arrow-double-2.png') no-repeat;
  background-size: 100% 100%;
}
.arrow-left-icon {
  width: 28px;
  height: 28px;
  background: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/arrow-left.png') no-repeat;
  background-size: 100% 100%;
  margin-right: 4px;
}
.arrow-right-icon {
  width: 28px;
  height: 28px;
  background: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/arrow-right.png') no-repeat;
  background-size: 100% 100%;
}
.menu-fab {
  position: fixed;
  top: 20px;
  left: 0;
  z-index: 9;
  .menu-text {
    background-color: #00000070;
    color: #fff;
    padding: 12px 20px 12px 12px;
    font-size: 25px;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    cursor: pointer;
    letter-spacing: 2px;
    margin-right: 20px;
    display: flex;
    align-items: center;
  }
}
.spread {
  opacity: 1;
  transition: all 0.5s ease;
}
.spread-hide {
  opacity: 0;
  transform: translateX(-100vw);
}
.function {
  display: flex;
  align-items: center;
  opacity: 0;
  transform: translateX(-100vw);
  transition: all 0.5s ease;
}

.function-show {
  opacity: 1;
  transform: translateX(0);
}

.swiper-slide1 {
  background-color: #000;
}

audio {
  display: none;
}
.toast-content {
  background-color: #00000080;
  border-radius: 8px;
  color: #fff;
  padding: 12px 20px;
}
.loading-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: transparent;
  border: 4px solid #222;
  border-top-color: #009688;
  -webkit-animation: 1s musicRote linear infinite;
  animation: 1s musicRote linear infinite;
}
.loading-text {
  font-size: 16px;
  margin-top: 12px;
}
.music {
  position: fixed;
  top: 40px;
  right: 40px;
  z-index: 9;
  width: 40px;
  height: 40px;
  cursor: pointer;
  background: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/music.png') no-repeat;
  background-size: 100% 100%;
}
.music-on {
  animation: musicRote 2s infinite linear;
}

.swiper-btn-right,
.swiper-btn-left {
  position: absolute;
  z-index: 2;
  top: 50%;
  width: 55px;
  height: 96px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: -48px;
  cursor: pointer;
}
.swiper-btn-left {
  left: 0;
  background-image: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/swiper-left.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.swiper-btn-right {
  right: 0;
  background-image: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/swiper-right.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.swiper-btn-right.disabled,
.swiper-btn-left.disabled {
  opacity: 0.1;
  cursor: default;
}
#home-swiper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .swiper-slide1 {
    position: relative;
    .index-bg-v {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: inherit;
    }
  }
}

.modal-wrap {
  position: relative;
  .close-mp3 {
    position: absolute;
    width: 44px;
    height: 44px;
    cursor: pointer;
  }
  .modal-header {
    padding: 8px;
    border-radius: 10px;
    top: -45px;
    z-index: -1;
    left: 43px;
    box-shadow: -4px 4px 11px rgba(0, 0, 0, 0.5);
    position: absolute;
    .modal-header-wrap {
      width: 120px;
      height: 36.83px;
    }
  }
  .modal-content {
    border: 8px solid #f4bc45;
    border-radius: 50px;
    overflow: hidden;
    box-shadow: -4px 7px 10px rgba(0, 0, 0, 0.2);
    video {
      width: 900px;
      display: block;
    }
  }
  .modal-close {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    color: #fff;
    right: -30px;
    top: 40px;
    padding: 10px 8px;
    z-index: -1;
    border-radius: 8px;
    box-shadow: -4px 4px 9px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    .close-icon {
      margin-top: 8px;
      width: 16px;
      height: 16px;
      background: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/close.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}

.modal-nver {
  position: absolute;
  width: 600px;
  background-color: #296914;
  padding: 8px;
  border-radius: 30px;
  video {
    width: 100%;
    border-radius: 30px;
  }
  .nv-content {
    line-height: 32px;
    color: #fff;
    padding: 12px 16px;
    font-size: 24px;
    font-family: '楷体', '楷体_GB2312';
    text-indent: 2em;
  }
  .modal-close {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    color: #fff;
    right: -32px;
    top: 30px;
    padding: 12px 10px;
    z-index: -1;
    border-radius: 8px;
    box-shadow: -4px 4px 9px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    background-color: #296914;
    .close-icon {
      margin-top: 8px;
      width: 16px;
      height: 16px;
      background: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/close.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}

@keyframes musicRote {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue